import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ComprobantesViewComponent } from 'src/app/components/comprobantes/components/comprobantes-view/comprobantes-view.component';
import { ErrorService } from 'src/app/shared/services/error/error.service';
import { OrdenesService } from 'src/app/shared/services/ordenes_entrega/ordenes.service';

const EMPTY_ORDER : any = {
  'Id' : undefined,
  'Estado' : 0,
  'DatosEntrega' :{
    'Calle' : '',
    'CalleNumero' : '',
    'Localidad' : {
      'Nombre': ''
    }
  }
}

@Component({
  selector: 'app-ordenes-entrega-view',
  templateUrl: './ordenes-entrega-view.component.html',
  styleUrls: ['./ordenes-entrega-view.component.scss']
})
export class OrdenesEntregaViewComponent implements OnInit {
  @Input() ordenId: number;

  public orden : any;
  public formComprobante: FormGroup;
  public cantidadTotal: number = 0;
  public enviadosTotal: number = 0;
  public cantidadItems: number = 0;

  constructor(public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private modalService:NgbModal,
    private errorService: ErrorService,
    private ordenesService: OrdenesService) {
    this.formComprobante = this.fb.group({
      datosEntrega: [''],
      nroOrden: [''],
      nroGrupo: [''],
      fecha: [''],
      hora: [''],
      fechaEnvio: [''],
      sucursal: [''],
      Observacion: [''],
    })
   }

  ngOnInit(): void {
    this.orden = EMPTY_ORDER;
    this.onSearch();
    this.loadForm();
  }

  onSearch() {
    const susc = this.ordenesService.getOrdenId(this.ordenId).subscribe(
      (data:any) => {
        if (data.Data !== undefined){
          this.orden = data.Data;
          this.loadForm();
        }
      },
      (error: any) => {
        this.errorService.getError(error.status);
      }
    );
    susc.unsubscribe;
  }

  loadForm(){
    if (this.orden.Id !== undefined){
      this.formComprobante = this.fb.group({
        datosEntrega: [this.getStrDatosEntrega()],
        nroOrden: [this.orden.Numero.padStart(8,'0')],
        nroGrupo: [this.orden.NumeroGrupo.padStart(8,'0')],
        fecha: [this.orden.Fecha],
        hora: [this.orden.Hora],
        fechaEnvio: [this.orden.FechaEnvio],
        sucursal: [this.orden.Sucursal.Nombre],
        Observacion: [this.orden.Observacion],
      })
      this.getTotales(this.orden.Articulos);
    }
  }

  getStrDatosEntrega() : string{
    return this.orden.DatosEntrega.Calle.trim() + ' ' + this.orden.DatosEntrega.CalleNumero.trim() + 
          (this.orden.DatosEntrega.Piso != undefined ? (' ' + this.orden.DatosEntrega.Piso.trim()) : '') + (this.orden.DatosEntrega.Departamento != undefined ? (' ' + this.orden.DatosEntrega.Departamento.trim()) : '') +
           ', ' + this.orden.DatosEntrega.Localidad.Nombre.trim(); 
  }

  anularOrden(){
    this.activeModal.close('anular');  
  }

  getTotales(articulos: any){
    this.cantidadTotal = 0;
    this.enviadosTotal = 0;
    this.cantidadItems = 0;

    articulos.forEach(art => {
      this.cantidadItems ++;
      this.cantidadTotal += art.Cantidad;
      this.enviadosTotal += art.CantidadEnviada;
    });
  }

  getComprobante(idRemito: number){
    const modalRef = this.modalService.open(ComprobantesViewComponent, { size: <any>'xl'  });
      modalRef.componentInstance.comprobanteId = idRemito;
      modalRef.componentInstance.tipoComprobante = 'recibo';
      modalRef.result.then((resolve) => {
      }); 
  }

}
